import get from 'lodash/get';
import UserDatabases from '@Services/UserDatabases';
import Catalyst from '@Services/Catalyst';
import { _trackResults, _getLimitOrExcludeInfo, _getFacetsSearchType } from '@Pages/Results/analytics';

const AXIS_VALUES_MAP = {
  'DAT.ANAME': 'bio', // Bioassays
  'TARGET.HDR_KEY': 'tg', // Targets
  'DAT.TSPECIE': 'tgsp', // Target Species
  'DAT.BSPECIE': 'biosp', // Biological Species
  'DAT.EFFECT': 'e', // Effects
  'DAT.VTYPE': 'p', // Parameter
  'DAT.BCELL': 'cl', // Cell Lines
  'DAT.MRN': 's', // Substances
};

const CELL_OPERATIONS_MAP = {
  MAX: 'maxpx', // Maximum of pX
  MIN: 'minpx', // Minimum of pX
  MEDIAN: 'mdpx', // Median of pX
  AVERAGE: 'avgpx', // Average of pX
};

const SHOW_SUBSTANCES_MAP = {
  names: 'names',
  drawing: 'struct',
};

let skipNextHeatmapTracking = false;

function _getHeatmapDetails({ settings }) {
  const { showPopup, startInFullScreen, showSubstances, col, row, cellOperation } = settings;
  const detailsPairs = [
    ['x', AXIS_VALUES_MAP[col.value]],
    ['y', AXIS_VALUES_MAP[row.value]],
    ['cells', CELL_OPERATIONS_MAP[cellOperation]],
    ['show', SHOW_SUBSTANCES_MAP[showSubstances]],
    ['disp', startInFullScreen ? 'full' : 'norm'],
    ['alshow', showPopup ? 'y' : 'n'],
  ];
  return {
    details: detailsPairs.map((pair) => pair.join('=')).join('&'),
  };
}

export const setSkipNextHeatmapTracking = (skip) => {
  skipNextHeatmapTracking = skip;
};

export const trackHeatmap = async ({ params, activeBreadcrumb, heatmapData, settings }) => {
  try {
    // Do not track when sorting applied
    if (skipNextHeatmapTracking) {
      setSkipNextHeatmapTracking(false);
      return;
    }

    const colsAmount = get(heatmapData, 'viewOptions.colsAmount');
    const rowsAmount = get(heatmapData, 'viewOptions.rowsAmount');
    const totalResults = colsAmount * rowsAmount;

    const { context, databaseId } = params;
    const facets = activeBreadcrumb && activeBreadcrumb.facets;

    const trackingObject = {
      context,
      database: UserDatabases.getDbName(databaseId),
      totalResults,
      resultsByType: [
        {
          name: 'columns',
          results: colsAmount,
        },
        {
          name: 'rows',
          results: rowsAmount,
        },
      ],
      type: `${Catalyst.getPrefix()}:explicit:results:${context}`,
      ..._getLimitOrExcludeInfo({
        params,
        totalResults,
      }),
      ..._getFacetsSearchType({
        params,
        facets,
      }),
      ..._getHeatmapDetails({ settings }),
      ...(facets && { facets }),
    };

    _trackResults(trackingObject);
  } catch (e) {
    Logger.error(e);
  }
};
